
define('jst!leftnav/_org_nav_grants',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<li class="grants top-space <%= highlightGrants ? \'current\' : \'\' %>">\n  <a href="<%= routes.organization_grants_path(data.organization.url_label, {format:\'html\'}) %>"><span class="icon-16 icon-16-grant"></span><%= t(\'Shared with you #lefthand-nav\')%>\n    <% if(grantCount) { %>\n      <span class="shared-grants-counter primary baby-button"><%= grantCount %></span>\n    <% } %>\n  </a>\n</li>\n');
 });

